let copyTimer: any = null; // 타이머 저장용 변수
export let copy = (text: string, mgs: string) => {
    let doc = document.createElement("textarea");
    doc.textContent = text;
    document.body.append(doc);
    doc.select();
    document.execCommand("copy");
    doc.remove();

    let copyMsg = document.getElementById("copy-msg");

    // 기존 타이머가 있으면 클리어
    if (copyTimer) {
        clearTimeout(copyTimer);
    }

    // 기존 show 클래스 제거 (애니메이션 초기화)
    copyMsg.classList.remove("show");

    // 100ms 지연 후 다시 show 클래스 추가 (애니메이션이 보이도록)
    setTimeout(() => {
        copyMsg.textContent = mgs || "Copy completed!";
        copyMsg.classList.add("show");

        // 새로운 타이머 설정
        copyTimer = setTimeout(() => {
            copyMsg.classList.remove("show");
            copyTimer = null;
        }, 2000);
    }, 100); // 100ms 지연 추가
};

export let dateFormat = (timestamp: number) => {
    let currentDate = new Date(timestamp);
    let year = currentDate.getFullYear();
    let month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
    let day = ("0" + currentDate.getDate()).slice(-2);
    let dateStr = `${year}-${month}-${day}`;

    return dateStr;
};

export const getFileSize = (s: any) => {
    if (s <= 0 || s == null) {
        return "0 bytes";
    } else {
        let unit = ["bytes", "kB", "MB", "GB", "TB", "PB"];
        let e = Math.floor(Math.log(s) / Math.log(1024));
        return (s / Math.pow(1024, e)).toFixed(2) + " " + unit[e];
    }
};

export function formatServiceId(serviceId: string, ownerId: string) {
    // format service ID
    const alphabet = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
    ];

    const regionKeys = [
        "us31",
        "us72",
        "ap51",
        "ap22",
        "ap41",
        "eu71",
        "ap21",
        "us32",
        "us71",
        "af51",
        "ap31",
        "ap43",
        "ap23",
        "ap42",
        "ca01",
        "eu01",
        "eu72",
        "eu51",
        "eu73",
        "eu11",
        "me51",
        "sa31",
    ];

    const regionIndex = regionKeys.indexOf(serviceId.slice(0, 4));
    const regionChar = alphabet[regionIndex];
    const subRegionId = serviceId.slice(4, -4);

    return `${subRegionId}-${regionChar}${serviceId.slice(-4)}-${ownerId}`;
}
